export const pointDate = '09/15';

export const rewardMilestones = [
  { milestone: 5, type: '回饋金', value: '333', unit: '元', icon: 'gift' },
  { milestone: 10, type: '回饋金', value: '555', unit: '元', icon: 'gift' },
  { milestone: 15, type: '延後一天', value: '+1', unit: '天', icon: 'calendar' },
  { milestone: 20, type: '回饋金', value: '888', unit: '元', icon: 'gift' },
  { milestone: 25, type: '回饋金', value: '1,388', unit: '元', icon: 'gift' },
  { milestone: 30, type: '延後三天', value: '+3', unit: '天', icon: 'calendar' },
];

export const activityRules = [
  '每完成一筆符合資格的申請並成功撥款，即可獲得 1 點。',
  '累積達指定點數，可獲得對應回饋或延後天數。',
  '實際資格、回饋內容與發放時間，以公司最終審核為準。',
];
